import axios from 'axios';
import { API } from './constants';

export const TOKEN_KEY = 'mygoal-auth-token';
export const LOGGED_OUT_KEY = 'mygoal-explicitly-signed-out';
export const getSessionToken = () => {
  const persisted = localStorage.getItem(TOKEN_KEY);
  if (persisted) {
    sessionStorage.removeItem(TOKEN_KEY);
    return persisted;
  }
  // Preserve an already-open login when upgrading from tab-only sessions.
  const legacy = sessionStorage.getItem(TOKEN_KEY);
  if (legacy) {
    localStorage.setItem(TOKEN_KEY, legacy);
    sessionStorage.removeItem(TOKEN_KEY);
  }
  return legacy;
};
export const clearSession = () => {
  localStorage.setItem(LOGGED_OUT_KEY, 'true');
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem('mygoal-user-id');
  localStorage.removeItem('mygoal-admin');
  window.dispatchEvent(new Event('mygoal-session-cleared'));
};
export const acceptSession = (profile) => {
  if (!profile.access_token) throw new Error('Please sign in again');
  localStorage.setItem(TOKEN_KEY, profile.access_token);
  localStorage.removeItem(LOGGED_OUT_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  const { access_token, ...safeProfile } = profile;
  return safeProfile;
};

// Only attach credentials to this app's backend, never to third-party requests.
axios.interceptors.request.use(config => {
  const url = new URL(config.url, window.location.origin);
  const backend = new URL(API, window.location.origin);
  const token = getSessionToken();
  if (url.origin === backend.origin && url.pathname.startsWith(`${backend.pathname}/`.replace(/\/+/g, '/'))) {
    config.headers = config.headers || {};
    config.withCredentials = true;
    config.headers['X-MyGoal-Client'] = '1';
    const hasExplicitCredentials = Object.keys(config.headers).some(key => key.toLowerCase() === 'authorization');
    if (token && !hasExplicitCredentials) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
